import { useTranslation } from 'react-i18next'

import type { StepError, StepErrorField } from '../useOnboardingState'

/**
 * Binds a step's validation failure to the `Form.Item` it belongs to. Spread
 * the result onto the item: AntD marks that control red and prints the message
 * under it, which beats a banner at the end of the step that leaves the user
 * hunting for the field at fault.
 */
export const useFieldError = (error: StepError) => {
  const { t } = useTranslation()

  return (field: StepErrorField) =>
    error?.field === field
      ? { validateStatus: 'error' as const, help: t(error.key) }
      : {}
}
